<template>
    <div class="card mb-3">
        <div class="card-body">
            <button class="btn btn-info mr-2" data-toggle="collapse" data-target="#advanced">جستجو پیشرفته</button>
            <div class="collapse fade mt-3" id="advanced">
                <div class="row mt-2">
                    <div class="col-md-3">
                        <label>نقش</label>
                        <select class="form-control" v-model="isAdmin">
                            <option :value="item.id" v-for="(item, index) in adminList" :key="index">{{
                                item.title }}</option>
                        </select>
                    </div>

                    <div class="col-md-3">
                        <label>نوع درخواست</label>
                        <select class="form-control" v-model="tourist">
                            <option :value="item.id" v-for="(item, index) in touristList" :key="index">{{
                                item.title }}</option>
                        </select>
                    </div>

                    <div class="col-md-3">
                        <label>وضعیت</label>
                        <select class="form-control" v-model="statusId">
                            <option :value="item.id" v-for="(item, index) in statusList" :key="index">{{
                                item.title }}</option>
                        </select>
                    </div>
                </div>
                <div class="row mt-2" >
                    
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>نام</label>
                            <input type="text" class="form-control" v-model="name">
                        </div>
                    </div>

                    <div class="col-md-3">
                        <label> سوویچ ها </label>
                        <select class="form-control" v-model="switchId">
                            <option :value="item.id" v-for="(item, index) in switchList" :key="index">{{
                                item.title }}</option>
                        </select>
                    </div>

                    <div class="col-md-4  ">
                        <button class="btn btn-primary mx-2" style="margin-top:29px" @click="search">
                            <i class="si si-magnifier"></i>
                            جستجو
                        </button>
                        <button class="btn btn-danger" v-on:click="removeFilter" style="margin-top:29px"
                            v-if="!isAdvanced">حذف فیلتر</button>

                    </div>
                </div>
            </div>
            <hr>
             <div v-if="$store.state.role == 'admin' ">
                  <div class=" my-4">
                    <router-link style="display: contents;" target="_blank" class="nav-link" :to="{name: 'organizationForeigners.consumer.create' }">
                        <button class="btn btn-primary mx-2">
                            ایجاد همکار جدید
                        </button>
                    </router-link>
                </div>
            </div>
            
            <Loading v-if="showLoading" />

            <div class="table-responsive" v-if="rows.length" >
                <table class="table table-bordered table-hover mb-0">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>نام </th>
                            <th>نقش</th>
                            <th>وضعیت </th>
                            <th> نوع درخواست </th>
                            <th>عملیات </th>

                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(request, index) in rows" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ request.title }}</td>
                            <td>
                                <span v-if="request.isAdmin" class="badge badge-primary">ادمین</span>
                                <span v-else class="badge badge-secondary">کاربر</span>
                            </td>
                            <td>
                                <span v-if="request.status" class="badge badge-success">فعال</span>
                                <span v-else class="badge badge-danger">غیر فعال</span>
                            </td>
                            <td>
                                <span v-if="request.tourist" class="badge badge-warning">توریست</span>
                                <span v-else class="badge badge-dark">اتباع</span>
                            </td>
                            <td>
                                <button class="btn btn-icon">
                                     <router-link style="display: contents;" target="_blank" class="nav-link" :to="{name: 'organizationForeigners.consumer.view' , params: {id: request.id} }">
                                       <i class="ti-eye"></i>
                                    </router-link>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>

            <div class="alert alert-info mb-0" v-else>
                <p class="mb-0">داده ای یافت نشد</p>
            </div>
            

        </div>
    </div>
</template>

<script>

export default {
    name: 'Index',
    data() {
        return {
            rows: [],
            showLoading: false,
            name: "",
            isAdmin: 100,
            adminList :[{ id: 0 , title:"کاربر" }, {id:1 , title:"ادمین"} , {id: 100, title:"همه"}],
            tourist: 100,
            touristList :[{ id: 0 , title:"اتباع" }, {id:1 , title:"توریست"} , {id: 100, title:"همه"}],
            statusId : 100,
            statusList :[{ id: 0 , title:"غیر فعال" }, {id:1 , title:"فعال"} , {id: 100, title:"همه"}],
            switchId: 0,
            switchList : [],
            isAdvanced: true,
            columns: [
                {
                    title: 'نام',
                    field: 'title'
                },
                {
                    title: 'نقش',
                    field: 'isAdmin',
                },
                    {
                    title: 'وضعیت',
                    field: 'status'
                },
                {
                    title: 'نوع درخواست',
                    field: 'tourist'
                }
            ],
        }
        
    },
    methods: {
        async getSwitchData(){
            this.showLoading = true,
            this.$api.get('Organizations/Fida/Consumer/Switch/List').then(({ data }) => {
                this.switchList = data.result;
                this.showLoading = false;
            }).catch(() => {
                this.showLoading = false;
                this.$swal({
                    title: 'ناموفق',
                    icon: 'error',
                    text: ' داده ای  یافت نشد ,لذا مجدد اقدام کنید!'
                })
            })
        },
        async getData() {
            this.showLoading = true
            const body = {
                "authorizationToken": localStorage.getItem('agc-token'),
                "consumerId": 0,
                "isAdmin": this.isAdmin,
                "name": this.name,
                "tourist": this.tourist,
                "switch": this.switchId,
                "status": this.statusId,
            }

            this.$api.post('Organizations/Fida/Consumer/List', body).then(({ data }) => {
                if (data.status) {
                    this.showLoading = false;
                    this.rows = data.result ? data.result : [];
                }
                this.showLoading = false;
            }).catch(() => {
                this.showLoading = false;
                this.$swal({
                    title: 'ناموفق',
                    icon: 'error',
                    text: ' داده ای  یافت نشد ,لذا مجدد اقدام کنید!'
                })
            })
        },
        search() {
            this.isAdvanced = false;
            this.getData();
        },
        removeFilter() {
            this.name= "",
            this.isAdmin= 100,
            this.tourist= 100,
            this.statusId = 100,
            this.switchId= 0,
            this.isAdvanced = true;
            this.getData();
        },
    },
    created() {
        this.getSwitchData();
        this.getData();
    }
}
</script>